export default __webpack_public_path__ + "static/media/notFound.928bdb10.png";